import React, { useEffect, useState } from "react";
import useCustomNavigate from "../../../../common_nextgen/common_components/Navigation/NextGenNavigation";

import getBackendUrl from "../../../../environment/BackendService";
import { fetchDropdownValues } from "../../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";

import { ROUTE_PATHS} from "../../../../common_nextgen/utils/Constants";
import { useAxios } from "../../../../common_nextgen/axios/AxiosHelper";
import { useToast } from "../../../../common_nextgen/hooks/ToastContext";
import { downloadCSV } from "../../../../common_nextgen/utils/UtilFunctions";

const useThirdPartyException = (
  onSelect,
  hideModal,
  initialSelectParams,
  initialLookupType,
  selectModeParamData = null
) => {
  const [data, setData] = useState([]);
  const { axios_helper_no_header } = useAxios();
  const [paramsData, setParamsData] = useState({
    list: selectModeParamData?.thirdPartyException ?? "",
  }); /* */
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [selectedOption, setSelectedOption] = useState("no");
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [selectParams, setSelectParams] = useState(initialSelectParams);
  const toast = useToast();
  const location = useLocation();
  const {} = ROUTE_PATHS;

  const screen_title = "3rd Party Exception";
  const screenNumber = "RC3EX900";

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "3EX 3rd Party Excp Code",
      name: "list",
      label: "3rd Party Exception",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 1,
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        if (lookupType === "external") {
          const message = {
            type: "hideModal",
          };
          window.parent.postMessage(message, "*");
        } else {
          hideModal();
        }
      },
      button_key: "F12",
    },
  ];

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = [
    // {
    //   button_label: "Back",
    //   button_handeler: () => {
    //     navigateToPage("Back");
    //   },
    //   button_key: "F12",
    // },
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  /* Gear Icon Menu option CTAs */

  const menuOptions = [
    {
      label: "Select",
      icon: <span className="material-icons">add</span>,
      command: () => {
        const paramDataMap = new Map();
        selectParams.forEach((key) => {
        if (rowData.hasOwnProperty(key["target"])) {
          paramDataMap.set(key["source"], rowData[key["target"]]);
        }
      });
        const paramData = Object.fromEntries(paramDataMap);
        if (lookupType === "local") {
          onSelect(paramData);
        } else {
          const message = {
            type: "responseData",
            data: paramData,
          };
          window.parent.postMessage(message, "*");
        }
      },
    },
  ];

  /* Data table column info. */
  const columnDef = [
    {
      header: "3rd Party Exception",
      field: "thirdPartyException",
    },
    {
      header: "Description",
      field: "description",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "thirdPartyExcpCode";

  /* Handler that fetches the data */
  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/rc3exp`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const handleMessage = (event) => {
    try {
      const url = new URL(event.origin);
      const hostname = url.hostname;
      const isTrustedOrigin =
        hostname.endsWith(".optum.com") ||
        hostname === "localhost";
      if (!isTrustedOrigin) {
        console.warn("Blocked message from untrusted origin:", event.origin);
        return;
      }
      const { type, data } = event.data;
      console.log("iframe load", type, data);
  
      if (type === "initData") {
        const { selectMode, data: paramData } = data;
        console.log("external data", paramData, selectMode);
        setLookupType("external");
        setSelectParams(paramData.params);
        setParamsData(paramData.paramsData);
        // setSelectedPatient([...paramData.selectedSchedule]);
        // setSelectMode(selectMode);
      }
      console.log("message", event.data);
    } catch (error) {
      console.error("Invalid origin format:", event.origin);
    }
  };
  
  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };
  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchData(); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage, selectedOption]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/rc3exp/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    setSelectedOption,
    leftButtons,
  };
};

export default useThirdPartyException;
